'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactRedux = require('react-redux');

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _reactSelectFastFilterOptions = require('react-select-fast-filter-options');

var _reactSelectFastFilterOptions2 = _interopRequireDefault(_reactSelectFastFilterOptions);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _pacomo = require('utils/pacomo');

var _utilityFunctions = require('utils/utilityFunctions');

var _forms = require('metadata/forms');

var _apiHelper = require('api/api-helper');

var _components2 = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectInput = function SelectInput(_ref) {
    var intl = _ref.intl,
        id = _ref.id,
        name = _ref.name,
        input = _ref.input,
        hiddenValues = _ref.hiddenValues,
        requirement = _ref.requirement,
        options = _ref.options,
        loadResource = _ref.loadResource,
        queryParam = _ref.queryParam,
        fuzzyParam = _ref.fuzzyParam,
        resultParsing = _ref.resultParsing,
        placeholder = _ref.placeholder,
        helpText = _ref.helpText,
        _ref$meta = _ref.meta,
        active = _ref$meta.active,
        visited = _ref$meta.visited,
        touched = _ref$meta.touched,
        error = _ref$meta.error,
        locale = _ref.locale;

    var hideInput = false;
    var isHiddenValue = false;
    if (hiddenValues) {
        isHiddenValue = (0, _utilityFunctions.getResourceValue)(name, hiddenValues);
        hideInput = isHiddenValue;
        if (isHiddenValue && visited) {
            // TODO: make this less hacky?
            if (active || input.value !== '') {
                hideInput = false;
            }
        }
    }

    var inputProps = {
        id: id,
        className: (0, _classnames2.default)({ 'complete': requirement && requirement.status === 'COMPLETE' }),
        disabled: requirement && !requirement.editable
    };
    var selectProps = (0, _extends3.default)({}, inputProps, {
        placeholder: placeholder || intl.formatMessage(_forms.formPlaceholders.searchPrompt),
        searchPrompText: intl.formatMessage(_forms.formPlaceholders.searchPrompt),
        searchingText: intl.formatMessage(_forms.formPlaceholders.searching),
        noResultsText: intl.formatMessage(_forms.formPlaceholders.noResultsText),
        onBlur: function onBlur() {
            return input.onBlur(input.value);
        },
        onChange: function onChange(option) {
            return input.onChange(option ? option.value : '');
        }
    });

    var selectComponent = null;
    if (hideInput) {
        selectComponent = _react2.default.createElement('input', (0, _extends3.default)({}, input, inputProps, { value: '********', type: 'password' }));
    } else if (options) {
        selectProps.options = options || [];
        selectProps.filterOptions = (0, _reactSelectFastFilterOptions2.default)({ options: options });

        selectComponent = _react2.default.createElement(_reactSelect2.default, (0, _extends3.default)({}, input, selectProps));
    } else if (loadResource) {
        // If no resultParsing func provided, use default
        var resultParsingFunc = resultParsing || function (results) {
            return results.filter(function (result) {
                return result.id;
            }).map(function (result) {
                return {
                    label: '' + result.name,
                    value: result.id
                };
            });
        };
        selectProps.loadOptions = _lodash2.default.debounce(function (newInput, cb) {
            var sendEmpty = function sendEmpty() {
                return cb(null, { options: [] });
            };

            var fuzzy = void 0;
            var fieldValue = void 0;
            if (newInput && newInput.length >= 2) {
                // if the user types in new input into the selectInput, we want to search
                // using fuzzy query
                fuzzy = true;
                fieldValue = newInput;
            } else if (input.value) {
                // if input.value, we must preload the selectInput with preexisting selected value
                // using exact query (not fuzzy)
                fuzzy = false;
                fieldValue = input.value;
            }

            if (fieldValue) {
                (0, _apiHelper.loadOptions)({ input: fieldValue, queryParam: queryParam, resource: loadResource, fuzzy: fuzzy, fuzzyParam: fuzzyParam, locale: locale }).then(function (_ref2) {
                    var results = _ref2.results,
                        error = _ref2.error;

                    if (error) sendEmpty();
                    cb(null, {
                        options: results ? resultParsingFunc(fuzzy || queryParam ? results : [results]) : []
                    });
                }).catch(function (error) {}); // silently fail because we deal with error in .then()
            } else {
                sendEmpty();
            }
        }, 500);
        selectProps.filterOptions = function (options) {
            return options;
        }; // We let the server do all the filtering

        var selectRef = void 0;
        selectComponent = _react2.default.createElement(_reactSelect2.default.Async, (0, _extends3.default)({ ref: function ref(input) {
                return selectRef = input;
            } }, input, selectProps));
        if (active && isHiddenValue) {
            setTimeout(function () {
                selectRef.focus();
            }, 0);
        }
    }

    if (selectComponent) {
        return _react2.default.createElement(
            'span',
            null,
            selectComponent,
            _react2.default.createElement(_components2.FieldHelpErrorText, { touched: touched, error: error, helpText: helpText })
        );
    } else {
        return _react2.default.createElement('span', null);
    }
};
SelectInput.propTypes = {
    intl: _propTypes2.default.object.isRequired,
    id: _propTypes2.default.string.isRequired,
    // name: PropTypes.string.isRequired,
    input: _propTypes2.default.shape({
        value: _propTypes2.default.string.isRequired,
        onBlur: _propTypes2.default.func.isRequired,
        onChange: _propTypes2.default.func.isRequired
    }),
    hiddenValues: _propTypes2.default.object,
    requirement: _propTypes2.default.object,
    options: _propTypes2.default.array,
    loadResource: _propTypes2.default.string,
    queryParam: _propTypes2.default.string,
    fuzzyParam: _propTypes2.default.string,
    resultParsing: _propTypes2.default.func,
    placeholder: _propTypes2.default.string,
    helpText: _propTypes2.default.object,
    meta: _propTypes2.default.object.isRequired,
    locale: _propTypes2.default.string.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        locale: state.intl.locale
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactIntl.injectIntl)((0, _pacomo.pacomoTransformer)(SelectInput)));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/forms/SelectInput.js
// module id = 1349
// module chunks = 0